// extracted by mini-css-extract-plugin
export var accent = "_5z-4";
export var add = "_5z-j";
export var addIcon = "_5z-k";
export var deleteIcon = "_5z-i";
export var disabled = "_5z-9";
export var ellipsis = "_5z-f";
export var error = "_5z-3";
export var form = "_5z-5";
export var hideFocus = "_5z-2";
export var icon = "_5z-7";
export var input = "_5z-e";
export var listItem = "_5z-h";
export var mediumHeight = "_5z-b";
export var noBorder = "_5z-8";
export var noRadius = "_5z-1";
export var shortHeight = "_5z-a";
export var tallHeight = "_5z-c";
export var textInput = "_5z-0";
export var vertical = "_5z-g";
export var veryTallHeight = "_5z-d";
export var widget = "_5z-6";